const url = "https://fitnesstrac-kr.herokuapp.com/api";

export const logIn = async (username, password) => {
    try {
        const response = await fetch(`${url}/users/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                username: username,
                password: password
            })
        })
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};

export const register = async (username, password) => {
    try {
        const response = await fetch(`${url}/users/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                username: username,
                password: password
            })
        })
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};

export const getRoutines = async () => {
    try {
        const response = await fetch(`${url}/routines`);
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};

export const getRoutinesByActivity = async (activityId) => {
    try {
        const response = await fetch(`${url}/activities/${activityId}/routines`);
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
}

export const getActivities = async () => {
    try {
        const response = await fetch(`${url}/activities`);
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};

export const createActivity = async (token, name, description) => {
    try {
        const response = await fetch(`${url}/activities`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                name: name,
                description: description
            })
        });
        const result = response.json();
        return result;
    } catch (err) {
        console.error(err, "Unable to create. Activity may already exist.")
    }
}

export const createRoutine = async (token, name, goal) => {
    try {
        const response = await fetch(`${url}/routines`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                name: name,
                goal: goal,
                isPublic: true
            })
        })
        const result = response.json();
        return result;
    } catch(err) {
        console.error(err, "Unable to create routine");
    }
}

export const editRoutine = async (token, id, name, goal) => {
    try {
        const response = await fetch(`${url}/routines/${id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                name: name,
                goal: goal,
            })
        })
        const result = response.json();
        return result;
    } catch(err) {
        console.error(err, "Unable to create routine");
    }
}

export const getUser = async (token) => {
    try {
        const response = await fetch(`${url}/users/me`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};

export const getUserRoutines = async (username) => {
    try {
        const response = await fetch(`${url}/users/${username}/routines`);
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};

export const deleteRoutine = async (id, token) => {
    try {
        await fetch(`${url}/routines/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
    } catch (err) {
        throw err;
    }
};

export const deleteRoutineActivity = async (id, token) => {
    try {
        await fetch(`${url}/routine_activities/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
    } catch (err) {
        throw err;
    }
};


export const attachActivityToRoutine = async (routineId, activityId, count, duration) => {
    try {
        await fetch(`${url}/routines/${routineId}/activities`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                activityId: activityId,
                count: count,
                duration: duration
            })
        });
    } catch (err) {
        throw err;
    }
};

export const editRoutineActivity = async (token, routineActivityId, count, duration) => {
    try {
        await fetch(`${url}/routine_activities/${routineActivityId}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                count: count,
                duration: duration
            })
        })
    } catch (err) {
        throw err;
    }
};